import { Button, Grid, Typography } from "@mui/material";
import "../AppDesktop.css";
import ButtonCeci from "./ButtonCeci";

export default function Card4() {
    return (
        <Grid container size={12} sx={{width: '100%'}}>
            <Grid item size={1.5}/>
            <Grid item size={3.5} sx={{textAlign: 'left'}}>
                <div style={{marginTop: '17vw'}} className="stile-titolo bianco">Quando rivolgersi a me?</div>
                <div style={{marginTop: '6vw'}}className="stile-sottotitolo bianco">Per imparare a muovere il corpo in modo autonomo e consapevole, riscoprendo i benefici del movimento attraverso un percorso olistico e personalizzato, costruito sulle tue esigenze e i tuoi obiettivi.</div>
            </Grid>
        </Grid>
    );
}
